
export const SOME_ERROR_OCCURRED_KEY = 'someErrorOccured';

export const sharedAppI18nEnUS: Record<any, any> = {
  '*': {
    AT_ACTIONS_MENU: {
      save: 'Save',
      load: 'Load',
      validate: 'Validate',
      print: 'Print',
      schema: 'Schema',
      value: 'Value',
      error: 'Error',
      submit: 'Submit',
      language: 'Language',
      'clear-errors': 'Clear errors',

      'pt-PT': 'PT',
      'en-US': 'EN',

    },
    [SOME_ERROR_OCCURRED_KEY]: 'Unexpected Error!',
    'select-language': 'Select Language',
    validations: {
      UNALLOWED_VALUE_CODE: 'Value not allowed.',
      FREE_TEXT_INVALID_CHARACTER: 'Invalid special character in text.'
    },
  }
};
